import { HTMLAttributes } from 'react';

import { cn } from './cn';

/** shadcn/ui kbd: a keyboard key hint, for tooltips, menus and footers. */
export const Kbd = ({ className, ...props }: HTMLAttributes<HTMLElement>) => (
  <kbd
    data-slot="kbd"
    className={cn(
      'pointer-events-none inline-flex h-5 min-w-5 select-none items-center justify-center gap-1 rounded-sm',
      'border border-line bg-raised px-1 font-sans text-caption font-medium text-ink-muted',
      className,
    )}
    {...props}
  />
);

export const KbdGroup = ({ className, ...props }: HTMLAttributes<HTMLElement>) => (
  <kbd data-slot="kbd-group" className={cn('inline-flex items-center gap-1', className)} {...props} />
);
